var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootertelegramlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9975 6.07035L4.40249 16.3258C2.58749 17.0548 2.59799 18.0673 4.06949 18.5188L10.8975 20.6488L26.6955 10.6813C27.4425 10.2268 28.125 10.4713 27.564 10.9693L14.7645 22.5208H14.7615L14.7645 22.5223L14.2935 29.5603C14.9835 29.5603 15.288 29.2438 15.675 28.8703L18.9915 25.6453L25.89 30.7408C27.162 31.4413 28.0755 31.0813 28.392 29.5633L32.9205 8.22135C33.384 6.36285 32.211 5.52135 30.9975 6.07035Z",
    fill: "url(#paint0_linear_2640_10928)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2640_10928",
    x1: 18.0123,
    y1: 5.90479,
    x2: 18.0123,
    y2: 31.0844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootertelegramlogo);
export default __webpack_public_path__ + "static/media/footer telegram logo.c0496e74cc46a73c1c32a7260ffb1939.svg";
export { ForwardRef as ReactComponent };